class SlideshowSection extends BTSection {
  onInit() {
    this.slider = this.container.find(BT.getSliderSelector());
    this.slider.unbind('afterChange');
    const effect = BT.data.cacheWindowWidth < BT.options.windowScreen.desktop ? false : true;
    if(!Shopify.designMode) {
      const timeout = BT.data.cacheWindowWidth < BT.options.windowScreen.desktop ? 2300 : 0;
      setTimeout(() => {
        this.runSliderBanner(effect);
      }, timeout);
    } else {
      this.runSliderBanner(effect);
    }
    if(this.slider.hasClass('update-slider-pagination')) {
      this.slider.on('afterChange', (event, slick, currentSlide, nextSlide) => {
        const currentItem = slick.$slider.find('.slick-current').first();
        const prevText = currentItem.attr('data-page-prev-text');
        const prevImage = currentItem.attr('data-page-prev-img');
        const nextText = currentItem.attr('data-page-next-text');
        const nextImage = currentItem.attr('data-page-next-img');
        this.container.find('.slideshow__item__pagination-prev-text-content').text(prevText);
        this.container.find('.slideshow__item__pagination-prev-image').removeClass('lazyloaded').attr('data-src', prevImage).addClass('lazyload');
        this.container.find('.slideshow__item__pagination-next-text-content').text(nextText);
        this.container.find('.slideshow__item__pagination-next-image').removeClass('lazyloaded').attr('data-src', nextImage).addClass('lazyload');
      })
    }
  }

  runSliderBanner(effect) {
    this.container.find('.zoom-fade.lazyloaded').addClass('ignore-effect');
    BT.initSlider(this.container, true, effect);
  }

  onBlockSelect(evt) {
    var ele = $(evt.target);
    if(ele.attr('data-slick-index') != undefined) {
      this.slider.slick('slickGoTo', ele.attr('data-slick-index'), true).slick('slickPause');
    }
  }

  onBlockDeselect() {
    // Resume auto-rotate
    if(this.slider.hasClass('slick-initialized')) {
      this.slider.slick('slickPlay');
    }
  }

  onUnload() {
    BT.destroySlider(this.container);
  }
}
theme.sections.constructors['slideshow'] = SlideshowSection;